import * as Actions from './type';
import {
  getAllSettings,
  getUserNotificationsApi,
  setUsertSettings,
  readNotificationApi,
  viewNotificationApi,
  clearNotificationApi,
} from '../../api/settings/settings-apis';

// all settings to show
export const getAllNotificationsSettings = () => async (dispatch) => {
  try {
    dispatch({
      type: Actions.GET_NOTIFICATION_SETTINGS_REQUEST,
    });
    const { data } = await getAllSettings();
    dispatch({
      type: Actions.GET_NOTIFICATION_SETTINGS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: Actions.GET_NOTIFICATION_SETTINGS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// set user settings
export const createUserSettings = (settings) => async (dispatch) => {
  try {
    dispatch({
      type: Actions.SET_USER_NOTIFICATION_SETTINGS_REQUEST,
    });
    const { data } = await setUsertSettings(settings);
    dispatch({
      type: Actions.SET_USER_NOTIFICATION_SETTINGS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: Actions.SET_USER_NOTIFICATION_SETTINGS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// all user settings
export const getUserNotifications = () => async (dispatch) => {
  try {
    dispatch({
      type: Actions.GET_USER_NOTIFICATIONS_REQUEST,
    });
    const { data } = await getUserNotificationsApi();
    dispatch({
      type: Actions.GET_USER_NOTIFICATIONS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: Actions.GET_USER_NOTIFICATIONS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// read notification/change notification status
export const readNotifications = (notifications) => async (dispatch) => {
  try {
    dispatch({
      type: Actions.READ_NOTIFICATIONS_REQUEST,
    });
    const { data } = await readNotificationApi(notifications);
    dispatch({
      type: Actions.READ_NOTIFICATIONS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: Actions.READ_NOTIFICATIONS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// view notification
export const viewNotification = (notification) => async (dispatch) => {
  try {
    dispatch({
      type: Actions.VIEW_NOTIFICATION_REQUEST,
    });
    const { data } = await viewNotificationApi(notification);
    dispatch({
      type: Actions.VIEW_NOTIFICATION_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: Actions.VIEW_NOTIFICATION_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// clear notification
export const clearNotifications = () => async (dispatch) => {
  try {
    dispatch({
      type: Actions.CLEAR_NOTIFICATION_REQUEST,
    });
    const { data } = await clearNotificationApi();
    dispatch({
      type: Actions.CLEAR_NOTIFICATION_SUCCESS,
      payload: [],
    });
    dispatch({
      type: Actions.UPDATE_NOTIFICATIONS_LIST,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: Actions.CLEAR_NOTIFICATION_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};
